import { useContext } from 'react';
import { UserContext } from 'context/UserContext';

const useUserContext = () => {
  const ctx = useContext(UserContext);
  return { ...ctx };
};

export default useUserContext;
